/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {AutomationtriggersactionsData} from './AutomationtriggersactionsData';
import {AutomationtriggersactionsParams} from './AutomationtriggersactionsParams';

/**
 * The ActionsTriggerAutomationActionIdBody model module.
 * @module model/ActionsTriggerAutomationActionIdBody
 * @version 1.0.0
 */
export class ActionsTriggerAutomationActionIdBody {
  /**
   * Constructs a new <code>ActionsTriggerAutomationActionIdBody</code>.
   * @alias module:model/ActionsTriggerAutomationActionIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ActionsTriggerAutomationActionIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ActionsTriggerAutomationActionIdBody} obj Optional instance to populate.
   * @return {module:model/ActionsTriggerAutomationActionIdBody} The populated <code>ActionsTriggerAutomationActionIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ActionsTriggerAutomationActionIdBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('params'))
        obj.params = ApiClient.convertToType(data['params'], [AutomationtriggersactionsParams]);
      if (data.hasOwnProperty('data'))
        obj.data = AutomationtriggersactionsData.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
ActionsTriggerAutomationActionIdBody.prototype.title = undefined;

/**
 * @member {String} description
 */
ActionsTriggerAutomationActionIdBody.prototype.description = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
ActionsTriggerAutomationActionIdBody.TypeEnum = {
  /**
   * value: "send-email"
   * @const
   */
  send_email: "send-email"
};
/**
 * @member {module:model/ActionsTriggerAutomationActionIdBody.TypeEnum} type
 */
ActionsTriggerAutomationActionIdBody.prototype.type = undefined;

/**
 * @member {Boolean} enabled
 */
ActionsTriggerAutomationActionIdBody.prototype.enabled = undefined;

/**
 * @member {Array.<module:model/AutomationtriggersactionsParams>} params
 */
ActionsTriggerAutomationActionIdBody.prototype.params = undefined;

/**
 * @member {module:model/AutomationtriggersactionsData} data
 */
ActionsTriggerAutomationActionIdBody.prototype.data = undefined;

